import React from 'react';
import ReactDOM from 'react-dom';
import injectTapEventPlugin from 'react-tap-event-plugin';
import Main from './Main'; // Our custom react component
import List from './List';
import Select from './Select';

//Needed for onTouchTap
//Can go away when react 1.0 release
//Check this repo:
//https://github.com/zilverline/react-tap-event-plugin
injectTapEventPlugin();

// Render the main app react component into the app div.
// For more details see: https://facebook.github.io/react/docs/top-level-api.html#react.render
if(document.getElementById('app'))
  ReactDOM.render(<Main />, document.getElementById('app'));
if(document.getElementById('list'))
  ReactDOM.render(<List />, document.getElementById('list'));
if(document.getElementById('select'))
  ReactDOM.render(<Select />, document.getElementById('select'));



/** WEBPACK FOOTER **
 ** ./src/app/app.js
 **/